import { useContext, type FunctionComponent } from 'react';
import QuestionInterface from '../../../interfaces/question';
import { QuestionType } from '../../../interfaces/questionType';
import { SurveyPageContext } from '../../context/SurveyPageContext';
import ConditionalQuestion from '../ConditionalQuestion/ConditionalQuestion';
import QuestionFactory from '../utils/questionFactory';
import * as styles from './Question.module.css';

interface QuestionProps {
  question: QuestionInterface;
}

const Question: FunctionComponent<QuestionProps> = ({ question }) => {
  const questionType = question.type;
  const isRadioColor = QuestionType.RADIO_COLOR === questionType;
  const radioColorStyles = isRadioColor ? styles.radioColorQuestion : '';
  const { conditionalQuestionIds } = useContext(SurveyPageContext);
  const conditionalQuestionId = conditionalQuestionIds.get(question.id);

  return (
    <div className={`${styles.questionContainer} ${radioColorStyles}`}>
      <div className={styles.questionLabelContainer}>
        <p className={styles.questionLabel}>{question.value}</p>
        {question.caption && <p className={styles.questionSubLabel}>{question.caption}</p>}
      </div>
      <QuestionFactory question={question} />
      {question.disclaimer && <p className={styles.questionDisclaimer}>{question.disclaimer}</p>}
      {conditionalQuestionId &&
        conditionalQuestionId.length > 0 &&
        conditionalQuestionId.map((c) => <ConditionalQuestion key={c} conditionalQuestionId={c} />)}
    </div>
  );
};

export default Question;
